const INITIAL_STATE = {
  error: null,
  loading: null,
  data: [],
};

const Order = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "ORDER_GET_REQUEST":
      return { loading: true, error: false, data: [] };
    case "ORDER_GET_ERROR":
      return { loading: false, error: true, data: [] };
    case "ORDER_GET_SUCCESS":
      return { loading: false, error: false, data: action.payload };
    case "ORDER_GET_RESET":
      return { loading: false, error: false, data: [] };
    default:
      return state;
  }
};

export default Order;
